import React from "react";
import "../styles/style.css";
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa";

const SubmitResearch = () => {
  return (
    <div className="page-container">
      <main>
        <div className="intro">
          <h2>Submit Your Research</h2>
          <p className="description">
            Contribute to our growing database by submitting relevant research
            or recommending a publication for inclusion! Fill out the form below to share your work
            or suggest a title, and our team will review it for the database.
          </p>
          <a
            href="https://forms.gle/DooRr8U5k4rxiTHRA"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>Go to form</button>
          </a>
        </div>
      </main>
      <footer className="footer">
        <div className="copy">
          &copy; 2024&ndash;{new Date().getFullYear()} Impact Afghanistan - All Rights Reserved.
        </div>
        <div className="bottom-links">
          <div className="links">
            <a href="mailto:impactcompact.afghanistan@gmail.com">
              <FaEnvelope /> impactcompact.afghanistan@gmail.com
            </a>
            <a
              className="icon-link"
              href="https://www.linkedin.com/in/impactafghanistan/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              className="icon-link"
              href="https://www.instagram.com/impactafghanistan1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SubmitResearch;
